<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<mat-card class="block">
  <h2>Teams</h2>
  <div class="list" *ngIf="teams.length; else empty">
    <div class="row" *ngFor="let team of teams">
      <div>
        <strong>{{ team.name }}</strong>
        <div class="meta">
          {{ team.members.length || 0 }} members
          <span *ngIf="team.inviteCode"> · invite {{ team.inviteCode }}</span>
          <span *ngIf="team.gitHubRepoUrl"> · repo {{ team.gitHubRepoUrl }}</span>
        </div>
        <ul *ngIf="team.members.length">
          <li *ngFor="let m of team.members">{{ m.name || m.learnerId }} <span *ngIf="m.role">({{ m.role }})</span></li>
        </ul>
      </div>
    </div>
  </div>
  <ng-template #empty><p class="empty">No teams registered yet.</p></ng-template>
</mat-card>
